import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { useState } from "react";

import TunnelContext from "./TunnelContext";
import ConfigProvider from "./ConfigProvider";
import { useTranslation } from "react-i18next";
import ClubSelection from "./steps/ClubSelection";
import UserForm from "./steps/UserForm";
import Plans from "./steps/Plans";
import Sepa from "./steps/Sepa";
import Contract from "./steps/Contract";
import Payment from "./steps/Payment";
import Done from "./steps/Done";
import { StepConfirmation } from "./steps/StepConfirmation";
import GoogleTagManager from "./components/tracking/GoogleTagManager";
import PrivacyDidomi from "./components/tracking/PrivacyDidomi";
import FacebookPixel from "./components/tracking/FacebookPixel";

function App() {
  const hostname = window.location.hostname;

  let configCode = "onair.fr";

  // Spain
  if (hostname.endsWith("es") || hostname.endsWith("es.localhost")) {
    configCode = "onair.es";
    window.i18n.changeLanguage("es");
    document.title = "Me suscribo";
    document.documentElement.lang = "es";
  }
  // Morocco
  else if (hostname.endsWith("ma") || hostname.endsWith("ma.localhost")) {
    configCode = "onair.ma";
    window.i18n.changeLanguage("fr");
    document.title = "Je m'abonne";
    document.documentElement.lang = "fr";
  }
  // Preprod
  else if (hostname.endsWith("preprod.masalledesport.com") || hostname.endsWith("test") || hostname.endsWith("test.localhost")) {
    configCode = "onair.test";
    window.i18n.changeLanguage("es");
    document.title = "Me suscribo";
    document.documentElement.lang = "es";
  }
  // France
  else {
    configCode = "onair.fr";
    window.i18n.changeLanguage("fr");
    document.title = "Je m'abonne";
    document.documentElement.lang = "fr";
  }

  const [isDidomiReady, setDidomiReady] = useState(false);

  const handleDidomiReady = () => {
    setDidomiReady(true);
  };

  return (
    <>
      <PrivacyDidomi configCode={configCode} onDidomiReady={handleDidomiReady} />
      <GoogleTagManager configCode={configCode} isDidomiReady={isDidomiReady} />
      <FacebookPixel />
      <ConfigProvider configCode={configCode}>
        <ConfiguredApp />
      </ConfigProvider>
    </>
  );
}

export default App;

function ConfiguredApp() {
  return (
    <BrowserRouter>
      <TunnelContext>
        <Switch>
          <Route exact path={`/`} component={ClubSelection} />
          <Route exact path={`/user`} component={UserForm} />
          <Route exact path={`/plans`} component={Plans} />
          <Route exact path={`/sepa`} component={Sepa} />
          <Route exact path={`/contract`} component={Contract} />
          <Route exact path={`/card`} component={Payment} />
          <Route exact path={`/middle-confirmation`} component={StepConfirmation} />
          <Route exact path={`/confirmation`} component={Done} />
          <Redirect from={"*"} to={`/`} />
        </Switch>
      </TunnelContext>
    </BrowserRouter>
  );
}
